var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ErrorBoundary',[_c('router-view')],1),_c('my-ModelBox',{attrs:{"isShow":_vm.showSuccessBind},on:{"hide":_vm.showSuccessBinBox}},[_c('SuccessBindBox',{on:{"hide":_vm.showSuccessBinBox}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }